import React, { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { API, STORAGE_KEY, logError } from "./sections";

export function Gate({ onOk }) {
    const [pw, setPw] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!API) { setErr("URL backend non configurato. Contatta l'amministratore."); return; }
        setErr(""); setBusy(true);
        try {
            const r = await fetch(`${API}/api/hvac/auth`, { method: "POST", headers: { "X-Tech-Passcode": pw } });
            if (r.status === 401) throw new Error("Passcode non valido");
            if (r.status === 503) throw new Error("Area tecnica non configurata sul server. Contatta l'amministratore.");
            if (!r.ok) throw new Error(`Errore server (${r.status}). Riprova più tardi.`);
            sessionStorage.setItem(STORAGE_KEY, pw);
            onOk(pw);
        } catch (e2) {
            logError("Tech auth error:", e2);
            setErr(e2?.message || "Errore di rete. Verifica la connessione.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="min-h-[70vh] flex items-center justify-center bg-cb-dark cb-grid px-6">
            <form onSubmit={submit} data-testid="tech-gate" className="w-full max-w-md bg-white/5 border border-white/10 p-10 backdrop-blur-sm">
                <Lock className="text-cb-accent mb-4" />
                <div className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-2">Area riservata</div>
                <h1 className="font-display text-3xl font-bold text-white mb-2">Ufficio Tecnico</h1>
                <p className="text-slate-400 text-sm mb-6">Inserisci il passcode fornito dall'amministrazione per accedere al computo canalizzazioni.</p>
                <input
                    type="password"
                    data-testid="tech-passcode-input"
                    autoFocus
                    value={pw}
                    onChange={(e) => setPw(e.target.value)}
                    placeholder="Passcode"
                    className="w-full bg-transparent border border-white/20 text-white placeholder:text-slate-500 px-4 py-3 focus:outline-none focus:border-cb-accent"
                />
                {err && <div className="mt-3 text-sm text-red-400" data-testid="tech-error">{err}</div>}
                <button type="submit" disabled={busy || !pw} data-testid="tech-submit"
                    className="cb-glow mt-5 w-full inline-flex items-center justify-center gap-2 bg-cb-accent hover:bg-cb-accent/90 text-white px-6 py-3 font-medium disabled:opacity-50">
                    {busy ? <Loader2 className="animate-spin" size={16} /> : <Lock size={16} />} Accedi
                </button>
            </form>
        </section>
    );
}
